import styled from "@emotion/styled";

export const ScreenContainer = styled.div`
  width:100%;
  padding: 0 2rem;
  overflow: hidden;
`;

export const Container = styled.div`
height: 100vh;
  display: grid;
  grid-template-rows: 20% 80%;
`;
export const ImageContainer = styled.div`
width:30%;
min-width:150px;

background-size:100% 100%;
max-height: 200px;
justify-self: end;
margin:50px;
position: relative;
}
`;


export const ImageChange = styled.div`
    background: rgba(6, 12, 34, 0.76);
    cursor:pointer;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    text-align: center;
    padding-top: 40px;
    transition: all 300ms cubic-bezier(0.645, 0.045, 0.355, 1);
    
    
    
`;
 

export const HeaderContainer = styled.div`

height: 100vh;
display: grid;
grid-template-columns: repeat(2, 1fr);

`;


export const FormContainer = styled.div`
  display: grid;
  align-items: center;
  align-content: flex-start;
  padding-top: 10px;

  & Form {
    width: 60%;
  }
`;

export const H1 = styled.h1`
  padding: 20px 0px;
  text-align: left;
`;
export const InfoContainer = styled.div`
display: grid;
grid-template-columns: repeat(2, 1fr);
gap: 2rem;
`;

export const passwordContainer = styled.div`
display: grid;
grid-template-columns: repeat(2, 1fr);
gap: 2rem;
`;

export const InputContainer = styled.div`
  margin: 1rem 0;
  margin-top: 50px;
 
  position:relative;
  gap: 2rem;
  i {
    position: absolute;
    cursor: pointer;
    top: 13px;
    right: 20px;
  }
`;
export const updateContainer = styled.div``;
export const UpdateBtn = styled.button`
  margin-top: 2rem;
  padding: 0.8rem 38px;
  border: 0.5px solid #000;
  border-radius: 40px;
  background-color: transparent;
  color: #080808;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
  cursor: pointer;
`;

// // export const I = styled.i`
// color:#fff;

// `;
export const Eye = styled.i`
  color: #c3c3c3;
`;
export const Image = styled.img`
width:100%;`;